const Resources = {

    // table_headers: [
    //     {
    //         text:   "Name",
    //         align:  "start",
    //         value:  "name",
    //         type:   "link",
    //     },
    //     {
    //         text:   "Abbreviation",
    //         value:  "abbreviation"
    //     },
    //     {
    //         text:   "Facility",
    //         value:  "facility"
    //     },
    //     {
    //         text:   "Country",
    //         value:  "country"
    //     },
    //     {
    //         text:   "State",
    //         value:  "state" 
    //     },
    //     {
    //         text:   "Levels",
    //         value:  "level_counter"
    //     },
    //     {
    //         text:   'Sq. Footage',
    //         value:  'sq_footage'
    //     },
    // ],

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Dashboard",
            href: "#",
            arrow: "",
        },
    ],

    helps: [
        {
            label: 'Get the App on Google Play Store and Login', 
            instruction: `https://scribehow.com/embed/Get_the_App_on_Google_Play_Store_and_Login__fT4J5hv9TKuwclgCEQqlNw?as=scrollable`
        },
        {
            label: 'Get the App for iOS at the App Store', 
            instruction: `https://scribehow.com/embed/Get_the_app_for_iOS_at_The_App_Store__TuQVEvX4QHm0VStEPYa7sw?as=scrollable`
        },
        {
            label: 'Dashboard - Rooms Cleaned Update', 
            instruction: `https://scribehow.com/shared/Dashboard__Rooms_Cleaned_Update__UB2Wzyd0RWGNwtdjgYiF-A`
        },
    ]

}

export default Resources;